var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.fontClass},[_vm._v(_vm._s(_vm.values)),(_vm.appendValues)?_c('b',{staticClass:"f16"},[_vm._v("."+_vm._s(_vm.appendValues))]):_vm._e(),_c('b',{staticClass:"f12 margin-left-5 dark-2"},[_vm._v(_vm._s(_vm.unit)+_vm._s(_vm.last))])])
}
var staticRenderFns = []

export { render, staticRenderFns }